import { SVGProps, Ref, forwardRef } from 'react';

export const LineArrowRightEnterOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    d="M9.636 17.637 15.273 12 9.636 6.364 8.364 7.637l3.463 3.463H1v1.8h10.827l-3.463 3.464z"
                    fill="currentColor"
                />
                <path
                    d="M23 12c0 9.625-1.375 11-11 11v-1.8c2.393 0 4.14-.088 5.446-.334 1.289-.243 1.97-.608 2.39-1.03.422-.42.787-1.101 1.03-2.39.246-1.306.334-3.054.334-5.446s-.088-4.14-.334-5.446c-.243-1.289-.608-1.97-1.03-2.39-.42-.422-1.101-.787-2.39-1.03C16.14 2.888 14.392 2.8 12 2.8V1c9.625 0 11 1.375 11 11"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
LineArrowRightEnterOutlinedSize24Glyph.displayName = 'LineArrowRightEnterOutlinedSize24Glyph';
